module.exports = __webpack_public_path__ + "static/media/snack-fit.893a414e.jpg";